import Service from "../../AuthService";

const PaymentAccount = {
    getPaymentAccount(page){
        return Service.get("/payment_account?page="+page);
    },
    createPaymentAccount(data) {
        return Service.post("/payment_account", data)
    },
    getPaymentAccountById(id){
        return Service.get("/payment_account/"+id)
    },
    updatePaymentAccount(id, data) {
        return Service.put("/payment_account/" + id, data)
    },
    deletePaymentAccount(id) {
        return Service.delete("/payment_account/" + id)
    },
    searchPaymentAccount(page,data){
        return Service.post("/payment_account_search?page="+page, data)
    },
    getPaymentAccountAll(){
        return Service.get("/payment_account_all")
    },
    getPaymentAccountType(){
      return Service.get('/get_type_account');
    },
    generatePaymentAccountNumber(account_type){
        return Service.get(`generate_account_number?account_type=${account_type}`)
    },

    //Account Details
    getPaymentAccountDetailsById(id){
        return Service.get("/payment_account_details/"+id)
    },
    showPaymentAccountDetailsById(id){
        return Service.get("/payment_account_details/"+id)
    },
    createPaymentAccountDetails(data) {
        return Service.post("/payment_account_details", data)
    },
    updatePaymentAccountDetails(id, data) {
        return Service.put("/payment_account_details/" + id, data)
    },
    deletePaymentAccountDetails(id) {
        return Service.delete("/payment_account_details/" + id)
    },

    //mile seller
    getMileSeller(page,data){
        return Service.get(`/mile_seller?page=${page}&sale_id=${data.sale_id}&start_date=${data.start_date}&end_date=${data.end_date}`)
    },
    getMileSellerById(id){
        return Service.get("/mile_seller/"+id)
    },
    createMileSeller(data) {
        return Service.post("/mile_seller", data)
    },
    updateMileSeller(id, data) {
        return Service.put("/mile_seller/" + id, data)
    },
    deleteMileSeller(id) {
        return Service.delete("/mile_seller/" + id)
    },
    getDriverReport(data) {
        return Service.get(`/driver_sell_report?date_start=${data.date_start}&date_end=${data.date_end}`);
    },
};

export default PaymentAccount
